import { Ref, ref, computed } from "vue";

import { Flow } from "@/types/SyouninGroup";
import { ShinseiService } from "@/service/ShinseiService";
import { DialogService } from "@/service/DialogService";
import { Shinsei } from "@/types/Shinsei";
import OptionConst from "@/const/Option";
import { UtilService } from "@/service/UtilService";

export function useApproval() {
  const loading = ref(0) // APIで読み込みをする本数
  const isError = ref(false)
  // const isSaving = ref(false);
  const srv = new ShinseiService();

  const approval = async (data: Shinsei, targetId: number, syouninType: number, notes: string | null) => {
    loading.value++
    DialogService.nowloading('処理中...');

    data.approval_data = {
      target_id: targetId,
      syounin_type: syouninType,
      syounin_notes: notes
    }

    try {
      const res = await srv.approval(data)
      if (res !== null) {
        DialogService.info({
          text: `処理が終了しました`
        }, true);
      } else {
        DialogService.error({
          text: '予期せぬ事態が発生し登録に失敗しました'
        }, true);
      }
      loading.value--
      return resetFlowByDenied(res, syouninType)
    } catch (e: any) {
      await UtilService.showResponseErrorDialog(e)
      loading.value--
      return null
    }
  }

  const check = async (targetId: number, syouninType: number, notes: string | null) => {
    loading.value++
    DialogService.nowloading('処理中...');

    try {
      const res = await srv.check({
        target_id: targetId,
        syounin_type: syouninType,
        syounin_notes: notes
      })
      if (res !== null) {
        DialogService.info({
          text: `処理が終了しました`
        }, true);
      } else {
        DialogService.error({
          text: '予期せぬ事態が発生し処理に失敗しました'
        }, true);
      }
    } catch(e: any) {
      await UtilService.showResponseErrorDialog(e)
    }
    loading.value--
  }

  const resetFlowByDenied = (flow: Flow[], syouninType: number): Flow[] => {
    if(syouninType == OptionConst.SYOUNIN_STATUS.APPROVED){
      return flow
    }

    flow = flow.map((ele): Flow =>{
      if(ele.status_type == OptionConst.SYOUNIN_STATUS.WAIT){
        ele.status_type = -1
        ele.updated_at = ''
      }
      return ele
    })
    return flow
  }

  // 読み込み中か判断する
  const isSaving = computed(() => {
    return !(loading.value === 0 || isError.value)
  })

  return {
    isSaving,
    approval,
    check
  }
}
